<script setup lang="ts">
const props = defineProps<{
  icon: string;
  text: string;
}>();
</script>

<template>
  <li
    class="border-light-border dark:border-dark-border bg-light-item text-light-primary dark:bg-dark-item dark:text-dark-white mb-2 flex h-[66px] flex-col justify-center rounded-lg border px-3"
  >
    <div class="flex flex-row">
      <div class="flex flex-shrink-0 items-center">
        <img :src="props.icon" class="mr-3" />
      </div>
      <div>{{ props.text }}</div>
    </div>
  </li>
</template>
